import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/StoreConfigurationPageLoad'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class StoreConfigurationPageLoadStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "StoreConfigurationPageLoadStore",
			variables: false,
		})
	}
}

export async function load_StoreConfigurationPageLoad(params) {
  await initClient()

	const store = new StoreConfigurationPageLoadStore()

	await store.fetch(params)

	return {
		StoreConfigurationPageLoad: store,
	}
}
